import { render, staticRenderFns } from "./AffiliateDisputeLetters.vue?vue&type=template&id=435a23e8&"
import script from "./AffiliateDisputeLetters.vue?vue&type=script&lang=js&"
export * from "./AffiliateDisputeLetters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports